import { LanguageCodes } from 'global/constants';
import {
  BASE_LANGUAGE_OPTIONS,
  OTHER_LANGUAGE_OPTIONS,
} from '../lang/activity-language.constants';

export function getLanguageLabel(language: LanguageCodes) {
  return (
    BASE_LANGUAGE_OPTIONS.find(o => o.value === language)?.label ||
    OTHER_LANGUAGE_OPTIONS.find(o => o.value === language)?.label
  );
}
